import i18n from "../i18n";

/**
 * Maps an axios error to a translated, customer-facing message instead of
 * the raw Error/AxiosError text (e.g. "AxiosError: Request failed with
 * status code 429") that used to reach the Error screen verbatim. Backend
 * response bodies are deliberately not surfaced here — they're written for
 * logs/debugging, not end users — so this maps purely by HTTP status.
 */
export function getHttpErrorMessage(err) {
  const status = err?.response?.status;

  switch (status) {
    case 400:
      return i18n.t("common.error.http.badRequest");
    case 401:
      return i18n.t("common.error.http.unauthorized");
    // Core's billing block - the org can't pay for it, which the person being verified can't fix.
    case 402:
      return i18n.t("common.error.http.unavailable");
    case 403:
      return i18n.t("common.error.http.forbidden");
    case 404:
      return i18n.t("common.error.http.notFound");
    case 409:
      return i18n.t("common.error.http.conflict");
    case 429:
      return i18n.t("common.error.http.rateLimited");
    default:
      if (status >= 500) {
        return i18n.t("common.error.http.serverError");
      }
      // A request that never got a response at all (offline, timeout, CORS,
      // DNS failure...) vs. anything else unrecognized.
      if (err?.request && !err?.response) {
        return i18n.t("common.error.http.network");
      }
      return i18n.t("common.error.http.generic");
  }
}
